import React, { createContext, useContext, useState, useEffect, ReactNode } from "react";

interface SafeCareRecipientViewContextValue {
  // Define your care recipient state and methods here
}

const SafeCareRecipientViewContext = createContext<SafeCareRecipientViewContextValue | undefined>(undefined);

export function SafeCareRecipientViewProvider({
  children,
  isAuthReady = false,
}: {
  children: ReactNode;
  isAuthReady?: boolean;
}) {
  const [isReady, setIsReady] = useState(!isAuthReady);

  useEffect(() => {
    if (isAuthReady && !isReady) {
      setIsReady(true);
    }
  }, [isAuthReady, isReady]);

  if (!isReady) {
    // Skip initialization until auth is ready
    return <>{children}</>;
  }

  return (
    <SafeCareRecipientViewContext.Provider value={{ /* state & methods */ }}>
      {children}
    </SafeCareRecipientViewContext.Provider>
  );
}

export function useSafeCareRecipientView() {
  const ctx = useContext(SafeCareRecipientViewContext);
  if (!ctx) throw new Error("useSafeCareRecipientView must be used within SafeCareRecipientViewProvider");
  return ctx;
}
